module.exports = __webpack_public_path__ + "static/media/workplace_cult.0a03a1ef.svg";